module.exports = __webpack_public_path__ + "img/avatar-two.63fe8474.png";